import { createSyncStore } from '../factory';

type UserContextState = {
  orgId: string;
};

type UserContextActions = {
  setOrgId: (orgId: string) => void;
};

/**
 * Synced store for user context data that the renderer pushes to the shell
 * (Electron main process) and the shell persists to `manageState` / `user_presets.json`.
 *
 * The renderer calls `useUserContextStore.getState().setOrgId(orgId)` on login and org switch.
 *
 * The shell subscribes via
 * `shellBridge.subscribe('user-context', cb, ['orgId'])` to persist changes.
 *
 * Channel: `user-context`
 */
export const useUserContextStore = createSyncStore<UserContextState, UserContextActions>({
  channel: 'user-context',
  syncKeys: ['orgId'],
  throttleMs: 50,
  syncOptions: { broadcastInitialState: false },

  state: {
    orgId: '',
  },

  actions: (set) => ({
    setOrgId: (orgId: string) => {
      set({ orgId });
    },
  }),
});
